import { SystemEventFilterType } from "@ats/ats-platform-dashboard";
import { SystemEventAssetFilterComponent } from "../components/system-event-asset-filter/system-event-asset-filter.component";


export const systemEventAssetFilterType: SystemEventFilterType = {
  name: 'systemEventAssetFilter',
  description: 'i18n:DASHBOARD.SYSTEMEVENTFILTER.ASSET',
  component: SystemEventAssetFilterComponent
};
